<template>
    <div>

            <el-form class="table"  :model="formData"  ref="formRef"  size="mini"  inline>
                <el-form-item class="alc" prop="num" :label="type=='purc'?$t('purchaseOrder_purchase_order_number'):$t('purchaseOrder_sales_order_number')" >
                    <span  style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{type=='purc'?formData.vc_no:formData.vc_xcode}}</span>
                </el-form-item>
                <el-form-item class="alc" prop="gsname" :label="$t('purchaseOrder_variety')" >
                    <span  style="display: inline-block;width: 100%">{{formData.vc_pzname}}</span>
                </el-form-item>
                <el-form-item class="alc" prop="gsname" :label="type=='purc'?$t('purchaseOrder_supplier'):$t('purchaseOrder_customer')" >
                    <span  style="display: inline-block;width: 100%">{{type=='purc'?formData.vc_gysname:formData.vc_khname}}</span>
                </el-form-item>
                <el-form-item class="alc" prop="gsname" :label="$t('purchaseOrder_quantity')" >
                    <span  style="display: inline-block;width: 100%">{{formData.f_num}}</span>
                </el-form-item>
                <el-button class="marr4"  @click="addCost" size="mini" :disabled="formData.canAddFee==0">{{'+'+$t('button_newly_added')}}</el-button>
                <el-button  class="btn"  size="mini" type="primary" @click="saveCost">{{$t('button_save')}}</el-button>

            </el-form>

        <div v-loading="loading">
            <el-table
                    border
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    size="mini"
                    :height="tableHeight"
                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    :highlight-selection-row="true"
                    :highlight-current-row="true"
                    :row-class-name="rowClassName">

                <el-table-column
                        prop="vc_fyname"
                        :label="$t('purchaseOrder_expense_type')"

                        min-width="131">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.new" style="width: 100%" @change="changeType(scope.row)"   v-model="scope.row.i_fyid" size="mini" filterable >
                            <el-option
                                    v-for="item in yfType"
                                    :key="item.i_fyid"
                                    :label="item.vc_fyname"
                                    :value="item.i_fyid">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_fyname}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vc_khname"
                        :label="$t('purchaseOrder_service_provider')"

                        min-width="200">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.new" style="width: 100%" @change="changekh(scope.row)" @clear="clearsearch(scope.$index)"
                                   clearable  remote :remote-method="remoteMethodkh"  v-model="scope.row.i_khid" size="mini" filterable >
                            <el-option
                                    v-for="item in cusData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_khname}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_num"
                        :label="$t('purchaseOrder_quantity')"
                        width="80"
                        align="right">
                </el-table-column>
                <el-table-column
                        prop="vc_bzname"
                        :label="$t('purchaseOrder_currency')"

                        min-width="120">
                    <template slot-scope="scope">
                        <el-select v-if="scope.row.new" style="width: 100%" @change="changeBz(scope.row)" v-model="scope.row.i_bzid" size="mini" filterable >
                            <el-option
                                    v-for="item in bzData"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                        <span v-else>{{scope.row.vc_bzname}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_je"
                        :label="$t('purchaseOrder_amount')"
                        align="right"

                        min-width="122">
                    <template slot-scope="scope" >
                        <div @click="selectAll" v-if="scope.row.new">
                            <el-input-number  class="right-input"  style="width: 100%" size="mini" :controls="false" :min="0" :precision="2"  v-model="scope.row.f_je">
                            </el-input-number>
                        </div>
                        <span v-else>{{scope.row.f_je}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_sl"
                        :label="$t('purchaseOrder_tax_rate')"
                        align="right"

                        min-width="122">
                    <template slot-scope="scope" >
                        <div @click="selectAll" v-if="scope.row.new">
                            <el-input-number  class="right-input"  style="width: 100%" size="mini" :controls="false" :min="0" :precision="$setPrecision.quantityPrecision"  v-model="scope.row.f_sl">
                            </el-input-number>
                        </div>
                        <span v-else>{{scope.row.f_sl}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_rate"
                        :label="$t('purchaseOrder_exchange_rate')"

                        width="122"
                        align="right">
                    <template slot-scope="scope" >
                        <div @click="selectAll" v-if="scope.row.new">
                            <el-input-number class="right-input" style="width: 100%" :controls="false" :min="0"  :precision="$setPrecision.quantityPrecision"  size="mini" v-model="scope.row.f_rate" ></el-input-number>
                        </div>
                        <span v-else>{{scope.row.f_rate}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="f_sqpay"
                        :label="$t('purchaseOrder_the_requested_payment_amount')"

                        min-width="155"
                        align="right">
                </el-table-column>
                <el-table-column :label="$t('purchaseOrder_operation')" width="70" align="center">
                    <template slot-scope="scope" v-if="scope.row.i_id==0">
                        <el-button size="mini" style="color: red"
                                   type="text"
                                   @click="handleDelete(scope.$index, scope.row)">{{$t('button_delete')}}</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </div>
    </div>
</template>

<script>
    import * as API from "./api";
    import {file_root} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: '',
        components:{

        },
        props:{
            Data:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                file_root:"",
                baseerp:"",
                mid:0,
                loading:true,
                tableHeight:0,
                tableData:[],
                yfType:[],
                cusData:[],
                bzData:[],
                pData:{},
                formData:{},
                type:'',
                i_khtype:2,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },

        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.pData=JSON.parse(JSON.stringify(this.Data));
            this.file_root = file_root;
            this.baseerp=baseerp;
            this.type=this.pData.type;
            this.formData=this.pData.row;
            console.log(this.pData,this.formData,this.type,'row')
            this.getbzlist();
            this.getkhlist('');//要注
            if(this.type=='purc'){
                this.getFeeType(0);
                this.getList('order_fy')
                //this.formData.canAddFee=0
            }
            if(this.type=='sale'){
                this.getFeeType(1);
                this.getList('sell_fy')
                //this.formData.canAddFee=1
            }
            this.$nextTick(function () {
                this.onResize();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                // console.log(n.h,this.tableHeight)
            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                const otherHeight =270;
                this.tableHeight = window.innerHeight - otherHeight;
                console.log( this.tableHeight,' this.tableHeight')
            },
            selectAll(e){
                //console.log(e,'e')
                this.$nextTick(()=>{
                    e.target.select()
                })
            },
            //费用类型
            async getFeeType(type){
                let param = {
                    "i_feetype":type ,// 0-采购 1-销售
                };
                let res = await API.getFeeType(param);
                if (res.code == 1) {
                    this.yfType = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeType(e){
                this.tableData[e.index].i_fyid=e.i_fyid;
                let choo = this.yfType.filter(item=>{
                    return item.i_fyid == e.i_fyid
                });
                //console.log(choo,'choo');
                if(choo.length>0){
                    this.tableData[e.index].vc_fyname=choo[0].vc_fyname;
                    this.tableData[e.index].f_sl=choo[0].f_sl;
                    this.tableData[e.index].i_iscost=choo[0].i_iscost;
                    this.tableData[e.index].i_iswithorder=choo[0].i_iswithorder;
                    this.i_khtype=choo[0].i_khtype;
                    this.tableData[e.index].i_khid=0;
                    this.tableData[e.index].vc_khname='';
                    this.tableData[e.index].cusData=[];
                    this.getkhlist('');
                }else{
                    this.i_khtype='';
                    this.tableData[e.index].vc_fyname='';
                    this.tableData[e.index].f_sl=0;
                    this.tableData[e.index].i_iscost='';
                    this.tableData[e.index].i_iswithorder='';
                    this.tableData[e.index].i_khid=0;
                    this.tableData[e.index].vc_khname='';
                    this.tableData[e.index].cusData=[];
                }
            },
            //获取服务商
            remoteMethodkh(val) {
                this.getkhlist(val);
            },
            clearsearch(index) {
                this.tableData[index].vc_fyname='';
                this.tableData[index].i_khid=0;
                this.tableData[index].vc_khname='';
                this.tableData[index].cusData=[];
                this.getkhlist('');
            },
            async getkhlist(val){
                let param = {
                    currentPage: 1,
                    pageSize: 50,
                    vc_search:val,
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.cusData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changekh(e){
                //console.log(e,'e');
                this.tableData[e.index].i_khid=e.i_khid;
                let choo = this.cusData.filter(item=>{
                    return item.i_id == e.i_khid
                });
                //console.log(choo,'choo');
                if(choo.length>0){
                    this.tableData[e.index].vc_khname=choo[0].vc_name;
                }else{
                    this.tableData[e.index].vc_khname='';
                }
            },
            async getbzlist(){
                let param = {};
                let res = await API.getbzlist(param);
                if (res.code == 1) {
                    this.bzData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeBz(e){
                this.tableData[e.index].i_bzid=e.i_bzid;
                let choo = this.bzData.filter(item=>{
                    return item.i_id == e.i_bzid
                });
                //console.log(choo,'choo');
                if(choo.length>0){
                    this.tableData[e.index].vc_bzname=choo[0].vc_name;
                    this.tableData[e.index].f_rate=choo[0].f_rate;
                }else{
                    this.tableData[e.index].vc_bzname='';
                    this.tableData[e.index].f_rate=null;
                }
            },
            //列表list
            async getList(type){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    "i_ywid" : type=='order_fy'?this.formData.subId:this.formData.i_id,
                    "vc_type" : type // 采购-order_fy 销售-sell_fy
                };
                var res = await API.getOrderFees(param);
                /*var res={
                    "code": 1,
                    "message": "成功",
                    "data": [
                        {
                            "i_id": 1,
                            "i_fyid": 1001,
                            "vc_fyname": "",
                            "f_num": 1,
                            "f_je": 100.00,
                            "i_bzid": 0,
                            "f_rate": 1.0,
                            "vc_khname": "xx",
                            "vc_gsname": "1001",
                            "vc_no": "xx",
                            "vc_xcode": "xx",
                            "f_sl": "0.13",
                            "i_lruid": 1,
                            "vc_lruname": "王",
                            "vc_bzname": "CNY",
                            "dt_createtime": "",
                            "f_sqpay": "200.00" // 实付金额
                        }
                    ]
                }*/
                if (res.code==1){

                    this.loading=false;
                    this.Edit=false;
                    this.tableData=res.data;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            handleDelete(index, row){
                this.tableData.splice(index, 1);
            },
            addCost(){
                let map={
                    "i_id": 0,
                    "i_fyid": 0,
                    'vc_fyname':'',
                    "f_num": this.formData.f_num,
                    "f_je": 0,
                    "i_bzid": 0,
                    "f_rate": 0,
                    "i_khid": this.formData.i_khid,
                    "i_gsid": this.formData.i_gsid,
                    "vc_no": this.formData.vc_no?this.formData.vc_no:'', // 销售订单有就传，采购订单必传
                    "vc_xcode": this.formData.vc_xcode?this.formData.vc_xcode:'',// 销售订单必传
                    "f_sl": 0,
                    "i_pzid": this.formData.i_pzid,
                    "vc_type": this.type=='purc'?'order_fy':'sell_fy', // 采购 order_fy 销售 sell_fy
                    "i_ywid": this.type=='purc'?this.formData.subId:this.formData.i_id,
                    'f_sqpay':'0.00',
                    'new':true,
                    'vc_no_hs':this.type=='purc'?this.formData.vc_no_hs:null,
                    'i_xtype':this.type=='purc'?this.formData.i_xtype:null,
                    'i_iscost':'',
                    'i_iswithorder':'',
                }
                this.tableData.unshift(map)
            },
            validateData(oldList, addList) {
                if(addList.length==0){
                    this.$message.error(this.$t('purchaseOrder_no_additional_fees_can_be_saved'));
                    return false;
                }
                // 已保存
                const oldFyids = new Set(
                    oldList
                        .map(item => item.i_fyid)
                        .filter(id => id != 0)
                );
                console.log(oldFyids,'oldFyids')
                // 新增
                const newFyids = new Set();
                for (let i = 0; i < addList.length; i++) {
                    const item = addList[i];
                    if (item.i_fyid == 0) {
                        this.$message.error(this.$t('purchaseOrder_there_are_unselected_cost_types_in_the_data'));
                        return false;
                    }
                    if (Number(item.f_je) == 0) {
                        this.$message.error(this.$t('purchaseOrder_the_amount_cannot_be_zero'));
                        return false;
                    }
                    if (newFyids.has(item.i_fyid)) {
                        this.$message.error(this.$t('purchaseOrder_new_fee_types_cannot_be_duplicated'));
                        return false;
                    }
                    if (oldFyids.has(item.i_fyid)) {
                        this.$message.error(this.$t('purchaseOrder_the_fee_type_already_exists_and_cannot_be_added_again'));
                        return false;
                    }
                    newFyids.add(item.i_fyid);
                }
                return true;
            },
            saveCost(){
                const oldList = this.tableData.filter(item => item.i_id > 0);
                const validList = this.tableData.filter(item => item.i_id == 0);
                if (!this.validateData(oldList,validList)) {
                    return;
                }
                let sub=[];
                validList.forEach((b, index) => {
                    let hash = {
                        "i_id": b.i_id,
                        "i_fyid": b.i_fyid,
                        "f_num": b.f_num,
                        "f_je": b.f_je,
                        "i_bzid": b.i_bzid,
                        "f_rate": b.f_rate,
                        "i_khid": b.i_khid,
                        "i_gsid": b.i_gsid,
                        "vc_no": b.vc_no?b.vc_no:'', // 销售订单有就传，采购订单必传
                        "vc_xcode": b.vc_xcode?b.vc_xcode:'', // 销售订单必传
                        "f_sl": b.f_sl,
                        "i_pzid": b.i_pzid,
                        "vc_type": b.vc_type, // 采购 order_fy 销售 sell_fy
                        "i_ywid": b.i_ywid,
                        'vc_no_hs':this.type=='purc'?b.vc_no_hs:null,
                        'i_xtype':this.type=='purc'?b.i_xtype:null,
                        'i_iscost':b.i_iscost,
                        'i_iswithorder':b.i_iswithorder,
                    };
                    sub.push(hash);

                });
                console.log(sub,'sub')
                this.saveOrderFee(sub)
            },
            //保存
            async saveOrderFee(sub){
                this.disabled=true;
                this.loading=true;
                let param={
                    orderFeeList:sub,
                };
                let res=await API.saveOrderFee(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.visible=false;
                    this.getList(this.type=='purc'?'order_fy':'sell_fy');
                }else if (res.code == -2) {
                    this.disabled=false;
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },

            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                // console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                // console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                // console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    // console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
            },
        }
    }
</script>
<style  lang="scss" scoped>
    /deep/ .right-input .el-input__inner {
        text-align: right;
    }
    .cgdia {
        //弹出层里内容 样式
        /deep/.el-dialog__body {
            max-height: 85vh !important;
            overflow-y: auto;
            padding: 6px !important;
        }

    }
    .mar9{
        margin: 9px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 6px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>
